module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyt"
  }, [_vm._v("Publisher: AMY BARRETT-DAFFIN")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Creative Director: GAILEN RUNGE")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Acquisitions Editor: ROXANE CERDA")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Managing/Developmental Editor: LIZ ANELOSKI")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Technical Editor: DEBBIE RODGERS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover/Book Designer: APRIL MOSTEK")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Coordinator: ZINNIA HEINZMANN")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Editor: ALICE MACE NAKANISHI")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Illustrator: AIMEE RAY")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photo Assistant: KAELEY HAMMOND")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photography by ESTEFANY GONZALEZ of C&T Publishing, Inc., unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Published by Stash Books, an imprint of C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298d1aaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_copy.vue
// module id = 60
// module chunks = 0